import { Icon } from '@iconify/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { logout } from 'store/auth';
import cn from 'classnames';

const Header = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { user } = useSelector(state => state.auth);
  const { header } = useSelector(state => state.app);

  const { pathname } = useLocation();

  const welcome = ['/home', '/owned', '/asset/return'];

  const handleAction = () => {
    if (pathname === '/owned') {
      dispatch(logout());
      navigate('/intro');
    } else {
      navigate('/owned')
    }
  }

  return (
    <div className="w-full flex flex-col justify-center gap-4">
      {(welcome.includes(pathname) || welcome.some(pattern => pathname.startsWith(pattern))) ?
        <div className="flex justify-between items-center text-primary">
          <img
            alt="library"
            src="/library-logo.svg"
            className="w-20"
          />
          {/* <div>
            <span className="font-semibold uppercase text-sm">
              Bom dia {user.name}
            </span>
            <div className="flex items-center gap-1">
              <Icon icon="lucide:map-pin" className="text-secondary" />
              <span className="text-[#808080]">
                Sheraton {t('city.lisbon')}
              </span>
            </div>
          </div> */}
          <div>
            <div
              className={cn(
                'h-10 w-10 rounded-full flex justify-center items-center',
                {
                  'bg-secondary': pathname !== '/owned',
                  'bg-red-500': pathname === '/owned'
                }
              )}
              onClick={handleAction}
            >
              <Icon
                icon={pathname === '/owned' ? 'lucide:log-out' : 'heroicons-solid:bell'}
                width="20"
                className={cn(
                  {
                    'text-dark': pathname !== '/owned',
                    'text-white': pathname === '/owned'
                  }
                )}
              />
            </div>
          </div>
        </div>
        :
        <div className="flex justify-between items-center">
          <div>
            <div className="h-10 w-10 rounded-lg bg-[#EEEFF4] flex justify-center items-center" onClick={() => navigate(-1)}>
              <Icon icon="lucide:arrow-left" width="22" className="text-dark" />
            </div>
          </div>
          <div>
            <span className="text-xl font-semibold">
              {header.title}
            </span>
          </div>
          <div>
            <div
              className={cn(
                'h-10 w-10 rounded-full flex justify-center items-center',
                {
                  'bg-secondary': pathname !== '/owned',
                  'bg-red-500': pathname === '/owned'
                }
              )}
              onClick={handleAction}
            >
              <Icon
                icon={pathname === '/owned' ? 'lucide:log-out' : 'heroicons-solid:bell'}
                width="20"
                className={cn(
                  {
                    'text-dark': pathname !== '/owned',
                    'text-white': pathname === '/owned'
                  }
                )}
              />
            </div>
          </div>
        </div>
      }
    </div >
  );
};

export default Header;